<template>
    <div class="container-fluid h-100">
        <div class="row justify-content-center h-100">
            <div class="default-page-width h-100">
                <div class="card card-default">
                    <div class="card-header">{{$t('imprint.title')}}</div>
                    <div class="card-body">
                        <div>
                           <div v-if="$i18n.locale === 'de'">
                               <imprint-de></imprint-de>
                           </div>
                            <div v-else>
                                <imprint-en></imprint-en>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImprintDe from "./imprint-de.vue";
import ImprintEn from "./imprint-en.vue";

export default {
    name: "privacy-policy",
    props: ['reload', 'id'],
    components:{
        ImprintEn,
        ImprintDe
    },
    data: function(){
        return {
        }
    }
}
</script>

<style scoped>

</style>
